import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../../components/Auth/AuthLayout';
import AuthField from '../../components/Auth/AuthField';
import AuthTextarea from '../../components/Auth/AuthTextarea';
import { AppButton } from '../../components/AppButton/AppButton';

const userIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
  </svg>
);

const emailIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

const contactIntro = (
  <>
    <img src="/img/neuratrader_logo.png" alt="NeuraTrader" className="auth-page-logo" />
    <h1 className="auth-page-title">Contact us</h1>
    <p className="auth-page-subtitle">
      Have questions about NeuraTrader, bot setup, or your account? Send us a message and our team will get back to you.
    </p>
    <div className="auth-contact-cards">
      <div className="auth-contact-card">
        <p className="auth-contact-card-title">Support</p>
        <p className="auth-contact-card-text">Technical help with bots, orders, and platform features.</p>
      </div>
      <div className="auth-contact-card">
        <p className="auth-contact-card-title">Sales &amp; onboarding</p>
        <p className="auth-contact-card-text">Guidance on getting started and choosing the right setup for your strategy.</p>
      </div>
      <div className="auth-contact-card">
        <p className="auth-contact-card-title">Response time</p>
        <p className="auth-contact-card-text">We typically reply within 1–2 business days.</p>
      </div>
    </div>
  </>
);

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  function onChangeInput(event) {
    const { id, value } = event.target;
    if (id === 'name') setName(value);
    else if (id === 'email') setEmail(value);
    else setMessage(value);
  }

  function onSubmit(event) {
    event.preventDefault();

    const contactData = { name, email, message };

    try {
      console.log('Contact form submitted:', contactData);
      setSuccess('Your message has been sent successfully. We will be in touch soon.');
      setName('');
      setEmail('');
      setMessage('');
      setError('');
    } catch (err) {
      setError('There was an error sending your message. Please try again.');
      setSuccess('');
    }
  }

  return (
    <AuthLayout
      intro={contactIntro}
      withSiteFooter
      title="Contact us"
      description="Fill out the form and tell us how we can help."
      footer={(
        <>
          Prefer to explore first?{' '}
          <Link to="/" className="auth-link">Return to homepage</Link>
        </>
      )}
    >
      <form onSubmit={onSubmit}>
        <AuthField
          id="name"
          label="Full name"
          type="text"
          placeholder="Your name"
          icon={userIcon}
          autoFocus
          value={name}
          onChange={onChangeInput}
        />
        <AuthField
          id="email"
          label="Email"
          type="email"
          placeholder="you@company.com"
          icon={emailIcon}
          value={email}
          onChange={onChangeInput}
        />
        <AuthTextarea
          id="message"
          label="Message"
          placeholder="Tell us about your question or issue..."
          value={message}
          onChange={onChangeInput}
        />

        <AppButton type="submit" variant="primary" size="lg" fullWidth>
          Send Message
        </AppButton>

        {success && <div className="auth-alert auth-alert-success">{success}</div>}
        {error && <div className="auth-alert auth-alert-error">{error}</div>}
      </form>
    </AuthLayout>
  );
}

export default ContactPage;